import s from "../../styles/components/courses/course-card.module.scss";

export function convertLevelToCssClass(level: string) {
  switch (level) {
    case "rookie":
      return s.rookie;
    case "intermediate":
      return s.intermediate;
    case "advanced":
      return s.advanced;
    case "multiple":
      return s.multiple;
    case "notset":
      return s.notset;
    default:
      return s.multiple;
  }
}
